module.exports = __webpack_public_path__ + "static/media/vk2200.b0e7b3ef.jpg";